"use strict";

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GIPHY_REG_EX = /https:\/\/media\.giphy\.com\/media\/([A-Za-z0-9]+)\/giphy\.(mp4|gif)$/;

function isGiphyUrl(url) {
  return !!url.match(exports.GIPHY_REG_EX);
}

exports.isGiphyUrl = isGiphyUrl;